module.exports = __webpack_public_path__ + "img/icon-beneficiary.ed0d8d37.svg";